// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"218":"7c31e65c","285":"7c31e65c","505":"7c31e65c","766":"7c31e65c","849":"7c31e65c","893":"7c31e65c","965":"7c31e65c"}[chunkId] + ".chunk.css";
};